module.exports = __webpack_public_path__ + "img/banner-teacher-4.12e52af0.png";